import React, { Component, Suspense } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Switch} from 'react-router-dom';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import Scene from './components/scene/Scene'
import reducers from './reducers'
import './App.scss'
import Style from 'style-it';

import {default as i18n} from '@learningblocks/shared-components/lib/i18n';
import {Log} from '@learningblocks/shared-components/lib/EventLogger';
import {v4 as uuidv4} from 'uuid';
import {initDatadogSimulations} from "@labxchange/util-datadog";
import {UsersnapProvider, loadUsersnapSimulation} from "@labxchange/util-usersnap";

class SceneWrap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lang: 'en',
    }
  }
  useQuery = () => {
    return new URLSearchParams(this.props.location.search)?.get("lng");
  }

  componentDidUpdate(prevProps, prevState){
    if(prevState.lang !== this.state.lang){
      i18n.changeLanguage(this.state.lang)
    }
  }
  componentDidMount(){
    const query = this.useQuery();
    this.setState({
      lang: query
    });
  }

  render() {
    return (
      <>
      
      {(this.state.lang === "ar")?(
        <Style>
          {`
            p,
            span,
            i,
            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            h7,
            label,
            li,
            textarea
             {
              direction: rtl;
              text-align: right;
            }

            li.PowerSupplyLeads,
            .PowerLeads li {
              direction: ltr;
              text-align: left;
            }

            button {
              direction: rtl;
            }

            .card-header button {
              margin-right: 8px;
            }

            .singleChoiceQuestion label {
              padding-right: 68px !important;
              padding-left: 0 !important;
            }

            .singleChoiceQuestion .input .response .checkmark {
              margin-right: 0 !important;
              margin-left: 16px !important;
            }

            .predictionsSingleChoiceQuestion label {
              padding-right: 68px !important;
              padding-left: 0 !important;
            }

            .predictionsSingleChoiceQuestion .input .response .checkmark {
              margin-right: 0 !important;
              margin-left: 16px !important;
            }

            .modal-section.level-choice h2 {
              margin-right: 0 !important;
              position: relative;
              right: 0;
            }
            .modal-section.level-choice button {
              text-align: right !important;
            }

            .volume-modal-content .controls button p{
              text-align: center;
            }
            .protocol-view .protocol-head h4 .protocol-title-btn{
              margin-right: 8px;
            }
            .protocol-tasks-container .protocol-task .add-note-panel .btns {
              direction: ltr;
            }
            .protocol-task span {
              padding-right: 8px;
            }

            .controls__rpm--value p,
            .BlottingPaper ul {
              direction: ltr;
              text-align: left;
            }

            .prediction-results label{
              text-align: center;
              direction: ltr;
            }

            li#WaterBath,
            li#Trash,
            li.Solution,
            li.CellSpreader,
            .Material[role="Cell Spreader"] li,
            li.P2,
            li.P20,
            li.P200,
            li.P1000,
            .water-bath-temp h1, .water-bath-time h1,
            .water-bath-temp h3, .water-bath-time h3,
            .water-bath-controls .water-bath-temp h1, .water-bath-controls .water-bath-time h1,
            .water-bath-controls .water-bath-temp h3, .water-bath-controls .water-bath-time h3,
            .water-bath-start button{
              direction: ltr;
              text-align: left;
            }

            .Summary .learning-objectives ul {
              padding-right: 20px;
            }

            .Summary .learning-objectives ul li .index {
              right: -22px;
            }

            .Summary .learning-objectives ul li .index:after {
              right: 6px;
            }

         `}
        </Style>
      ):null}
      <UsersnapProvider
        onLoadCallback={(event, api)=>loadUsersnapSimulation(event, api, i18n.language)}
      >
        <div
          className="page-content wrapper"
          role="main">
          <Scene lang={this.state.lang} />
        </div>
      </UsersnapProvider>
      </>
    )
  }
}

class App extends Component {
  constructor (props) {
    super(props);
    initDatadogSimulations("1.4-using-the-micropipette");
  }

  render() {
    return (
      <Switch>
        <Route path="/" component={SceneWrap} />
      </Switch>
    )
  }
}

const store = createStore(reducers)
export default store.getState();

ReactDOM.render(
  <Suspense fallback="loading">
    <Provider store={store}>
      <BrowserRouter>
        <Log 
          sim_id={3}
          sim_name={'Using a micropipette'}
          sim_session_id={uuidv4()}
        >
          <App />
        </Log>
      </BrowserRouter>
    </Provider>
  </Suspense>,
  document.getElementById('container')
)
